import { render, staticRenderFns } from "./NavDesktop.vue?vue&type=template&id=f18356fc&"
import script from "./NavDesktop.vue?vue&type=script&lang=js&"
export * from "./NavDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f18356fc', component.options)
    } else {
      api.reload('f18356fc', component.options)
    }
    module.hot.accept("./NavDesktop.vue?vue&type=template&id=f18356fc&", function () {
      api.rerender('f18356fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/nav/NavDesktop.vue"
export default component.exports